import script from "./WhatsappFloat.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsappFloat.vue?vue&type=script&setup=true&lang=js"

import "./WhatsappFloat.vue?vue&type=style&index=0&id=709cda96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709cda96"]])

export default __exports__